import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <h1>BankSystem</h1>
        <p
          className="tagline"
          style={{ color: '#FFD700', fontWeight: 'bold', fontFamily: 'Helvetica, sans-serif' }}
        >
          BankSystem.eth Rocks DeFi: Cut Costs, AI Power, Freedom for Every Wallet!.
        </p>
      </div>
    </section>
  );
};

export default Hero;
